// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriptionsContext_container__Bk6_Q"};